export class SubscribePaidDTO {
    id;
    title;
    paidAt;
    endAt;
    status;
    subscribeId;
    autoRenew;

  constructor(options) {
    this.id = options?.id || null;
    this.title = options?.title || ""; //'FlowPik Pro'
    this.paidAt = new Date(options?.paidAt).getTime() || null;
    this.endAt = new Date(options?.endAt).getTime() || null;
    this.status = options?.status || null;
    this.subscribeId = options?.subscribeId || null;
    this.autoRenew = options?.autoRenew || false;
  }
}
